// extracted by css-extract-rspack-plugin
export default {"root":"root-p7TkVi","traceRow":"traceRow-tOPaXi","traceId":"traceId-A_sWCt","copyButton":"copyButton-bnjQAq","traceLabel":"traceLabel-rvHfzI"};